function useWildcard() {
    const hostname = window.location.hostname.split('.');
    let wildcard;

    if ((hostname.length === 3 && hostname[0] !== 'paymeme') || (hostname.length === 1 && hostname[0] === 'localhost')) {
        wildcard = hostname[0];
    }

    return { subdomain: hostname[0], wildcard };
}

export { useWildcard };
